<script>
  import { onMount } from 'svelte'
  import auth from 'services/auth/authService'
  import { emulateUser } from 'stores/auth'
  import { get } from 'svelte/store'
  import { userContext } from 'stores/info'
  import { createQuery } from '@tanstack/svelte-query'
  import { getUserContext } from 'services/api/apiCalls'

  const pendoKey = import.meta.env.VITE_PENDO_KEY

  export const addPendo = () => {
    if (pendoKey) {
      ;(function (apiKey) {
        ;(function (p, e, n, d, o) {
          var v, w, x, y, z
          o = p[d] = p[d] || {}
          o._q = o._q || []

          v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']
          for (w = 0, x = v.length; w < x; ++w)
            (function (m) {
              o[m] =
                o[m] ||
                function () {
                  o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)))
                }
            })(v[w])

          y = e.createElement(n)
          y.async = !0
          y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js'

          z = e.getElementsByTagName(n)[0]
          z.parentNode.insertBefore(y, z)
        })(window, document, 'script', 'pendo')
      })(pendoKey)
    }
  }

  export const initializePendo = (user, emulatedUser, organizationId) => {
    if (window.pendo) {
      let pendoVisitor = {
        id: user.user_object_id,
        email: user.email,
        fullName: user.name,
        roles: user.cn_roles,
      }

      if (emulatedUser) {
        pendoVisitor.emulatedUser = emulatedUser
      }

      let pendoAccount = organizationId ? {
        id: organizationId
      } : undefined

      window.pendo.initialize({
        visitor: pendoVisitor,
        account: pendoAccount,
      })
    }
  }

  onMount(() => {
    addPendo()
  })

  const queryGetUserContext = createQuery({
    queryKey: ['queryGetUserContext'],
    queryFn: getUserContext,
  })

  $effect(() => {
    if ($queryGetUserContext.data) {
      const ctx = $queryGetUserContext.data
      userContext.set(ctx)

      auth.getUser().then(user => {
        const currentEmulatedUser = get(emulateUser)
        const organizationId = ctx?.organization?.organizationId
        initializePendo(user, currentEmulatedUser?.email, organizationId)
      })
    }
  })
</script>
